import { memo, useCallback } from 'react';

import { useTrackEnteredFullScreen, useTrackExitedFullScreen } from '@air/analytics';
import { MaximizeIcon, MinimizeIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

import { useFullscreenContext } from '~/components/AssetModalV2/shared/context/FullscreenContext';

export const AssetModalContentFooterFullscreenButton = memo(() => {
  const { isFullscreen, toggleFullscreen } = useFullscreenContext();
  const { trackEnteredFullScreen } = useTrackEnteredFullScreen();
  const { trackExitedFullScreen } = useTrackExitedFullScreen();

  const label = isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen';

  const handleToggleFullscreen = useCallback(() => {
    if (isFullscreen) {
      trackExitedFullScreen();
    } else {
      trackEnteredFullScreen();
    }

    toggleFullscreen();
  }, [toggleFullscreen, isFullscreen, trackEnteredFullScreen, trackExitedFullScreen]);

  return (
    <Tooltip label={label}>
      <IconButton
        adsIcon
        appearance="ghost"
        data-testid="ASSET_MODAL_CONTENT_FOOTER_FULLSCREEN_BUTTON"
        color="gray"
        onClick={handleToggleFullscreen}
        size="medium"
        label={label}
        icon={isFullscreen ? MinimizeIcon : MaximizeIcon}
      />
    </Tooltip>
  );
});

AssetModalContentFooterFullscreenButton.displayName = 'AssetModalContentFooterFullscreenButton';
